import me from "models/me";

export default function (nextState, replace, callback) {
    if (me.isSignedInFully() && me.using_temp_password) {
        const path = nextState.location.pathname;
        const search = nextState.location.search;
        replace({
            pathname: "/profile",
            query: { redirect: path + (search || "") },
        });
    }
    callback();
}
